import { type RouteRecordRaw } from 'vue-router';

export const aboutRoutes: RouteRecordRaw[] = [{
    path: 'information',
    name: 'about-information',
    meta: {
        public: true
    },
    component: () => import('./views/about/InformationView.vue')
}, {
    path: 'privacy-policy',
    name: 'about-privacy-policy',
    meta: {
        public: true
    },
    component: () => import('./views/about/PrivacyPolicyView.vue')
}, {
    path: 'terms-of-service',
    name: 'about-terms-of-service',
    meta: {
        public: true
    },
    component: () => import('./views/about/TermsOfServiceView.vue')
}];
